import { configureStore } from "@reduxjs/toolkit";
import employeeFormReducer from "./slices/employee-slice";

const store = configureStore({
  reducer: {
    employeeForm: employeeFormReducer,
  },
});

export default store;
